export default __webpack_public_path__ + "static/media/cases4.bc8713e3.jpg";